<script lang="ts">
  import Panel from '@components/panel.svelte'
  import {
    colorPlayOutcome,
    formatPitchType,
    formatPitchOutcome,
    type PitchAtBatEvent,
  } from '@statmuse/core/gamera'
  import Strikezone from './strikezone.svelte'

  interface Props {
    pitches: PitchAtBatEvent[]
    batterHandedness?: string
    autoScroll?: boolean
    class?: string
  }

  let {
    pitches,
    autoScroll = false,
    batterHandedness,
    class: classes = '',
  }: Props = $props()

  let pitchSequenceContainer: HTMLElement

  const mapPitchNumber = () => {
    let pitchNumber = 0
    return (p: PitchAtBatEvent) => ({
      ...p,
      pitchNumber:
        p.outcomeType === 'enforcedBall' || p.outcomeType === 'enforcedStrike'
          ? undefined
          : ++pitchNumber,
    })
  }

  let pitchesWithNumber = $derived(pitches.map(mapPitchNumber()) ?? [])

  $effect(() => {
    if (autoScroll) {
      pitchSequenceContainer.scrollTo({
        left: pitchSequenceContainer.scrollWidth,
        behavior: 'smooth',
      })
    }
  })
</script>

<Panel class={`!p-0 ${classes}`}>
  <div
    class="flex flex-col items-center border-b border-gray-6 dark:border-gray-4"
  >
    <Strikezone
      class="h-[280px]"
      {batterHandedness}
      pitches={pitchesWithNumber.filter((p) => p.pitchData)}
    />
  </div>
  <div
    bind:this={pitchSequenceContainer}
    class="min-h-[84px] flex items-center overflow-x-scroll no-scrollbar divide-x divide-gray-6 dark:divide-gray-4"
  >
    {#each pitchesWithNumber as pitch (pitch)}
      <div class="min-h-[84px] text-nowrap px-3 py-2 text-center">
        <div class="flex items-center justify-center gap-1.5 mb-1">
          <div
            class={`w-6 h-6 text-gray-7 rounded-full flex justify-center items-center ${colorPlayOutcome(
              pitch,
            )}`}
          >
            {#if pitch.pitchNumber}
              {pitch.pitchNumber}
            {/if}
          </div>
          <p class="capitalize">
            {formatPitchOutcome(pitch)}
          </p>
        </div>
        <div class="text-gray-5 text-sm leading-tight">
          {pitch.pitchData?.speed ? `${pitch.pitchData?.speed} mph` : ''}
          <span class="capitalize">{formatPitchType(pitch)}</span>
        </div>
        {#if pitch.pitchData?.spinRate || pitch.pitchData?.spinDirection}
          <div class="text-gray-5 text-sm leading-tight">
            Spin:
            {#if pitch.pitchData.spinRate}
              {pitch.pitchData?.spinRate} rpm,
            {/if}
            {#if pitch.pitchData.spinDirection}
              {pitch.pitchData?.spinDirection} deg
            {/if}
          </div>
        {/if}
      </div>
    {/each}
  </div>
</Panel>
